/* eslint-disable react-hooks/rules-of-hooks */
import { BaseTranslations } from '../../../../baseTranslations';
import { PushDataLayerFn } from '../../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../../utils/cmsPageContext/useCmsClientContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import Button from '../../../Button';
import { MaterialIcon } from '../../../MaterialIcon';
import { nextButtonStyles } from '../../constants';
import { useSafeCarInsuranceContext } from '../../context/useSafeCarInsurance';
import { PersonalDetailsForm } from '../../PersonalDetailsForm';
import { StepHeader } from '../StepHeader';

interface PersonalDetailsSingsaverProps {
  onNext: () => void;
  pushDataLayer: PushDataLayerFn;
}

export const PersonalDetailsSingsaver: React.FC<
  PersonalDetailsSingsaverProps
> = ({ onNext, pushDataLayer }) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  const carInsuranceContext = useSafeCarInsuranceContext();
  if (!carInsuranceContext) {
    return null;
  }

  const { form } = carInsuranceContext;

  const handleNextStep = async () => {
    form.setIsChanged(true);

    onNext();
  };

  return (
    <div className="mt-4 flex w-full flex-col gap-4">
      <StepHeader
        title={staticText.personal_details}
        subTitle={staticText.personal_details_subtitle}
        stepNumber={2}
      />
      <PersonalDetailsForm
        useBolttechData={true}
        pushDataLayer={pushDataLayer}
      />
      <Button className={nextButtonStyles} onClick={handleNextStep}>
        {staticText.next}
        <MaterialIcon
          icon="arrow_right_alt"
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="text-white text-[22px]"
        />
      </Button>
    </div>
  );
};
